/* userGroup/reducer */
import { createReducer } from "typesafe-actions";
import { BranchActionTypes, BranchState } from "./types";
import { fetchRequest, fetchSuccess, fetchError } from "./actions";

export const initialState: BranchState = {
  data: undefined,
  errors: undefined,
  loading: false,
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>;

export default createReducer<BranchState, ActionType>(initialState)
  .handleType(BranchActionTypes.FETCH, (state) => {
    return { ...state, loading: true };
  })
  .handleType(BranchActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(BranchActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
    };
  });
